import moment from 'moment'
import {
  REQUEST_DATA_SUCCESS,
  LOAD_DATA_SUCCESS,
  LOAD_GRAPH_SUCCESS
} from './mutation-types'

export default {
  [REQUEST_DATA_SUCCESS](state, payload) {
    state.tabs = payload.map(
      ({
        Id,
        Nome,
        TemDadosDiarios,
        TemDadosMensais,
        TemDadosSemanais,
        TemDadosAnuais
      }) => {
        return {
          cadeia: Id,
          nome: Nome,
          frequencia: 1,
          items: [],
          diario: TemDadosDiarios,
          mensal: TemDadosMensais,
          semanal: TemDadosSemanais,
          anual: TemDadosAnuais
        }
      }
    )
  },

  [LOAD_DATA_SUCCESS](state, { cadeia, data }) {
    const tab = state.tabs.find(t => t.cadeia === cadeia)
    if (tab) {
      tab.items = data.map(i => {
        i.check = false
        i.fData = moment(i.Data).format('L')
        return i
      })
    }
  },

  [LOAD_GRAPH_SUCCESS](state, payload) {
    state.graph = payload
  }
}
